import { Flex } from "@chakra-ui/react";
import { useConditionalBackground } from "@/contexts/useConditionalBackground ";
import Logo from "@/components/Logo";
import { useParams } from "react-router-dom";
import { resolveFlowType } from "@/components/Flows/flowRegistry";
import { flows } from "@/components/Flows/flowRegistry";

export default function Login() {
  const backgroundStyle = useConditionalBackground();
  const { shorthash } = useParams<{ shorthash: string }>();
  const flowType = resolveFlowType(shorthash);
  const flow = flows[flowType];
  return (
    <Flex
      minW="100vw"
      minH="100vh"
      {...backgroundStyle}
      flexDirection="column"
      align="center"
      pt="10%"
    >
      <Flex w="100%" justify="center">
        <Logo variant="primary" alt="Logo" boxSize="50%" mt="10%" />
      </Flex>
      {/* <Flex w="100%" justify="center">
        <Text
          fontSize="xl"
          color="white"
          textAlign="center"
          mt="4rem"
          px="4"
          maxWidth="80%"
        >
          Falta pouco para concluir seu contrato.
        </Text>
      </Flex> */}
      <Flex w="100%" justify="center" mt="8">
        {flow.loginForm(shorthash ?? "")}
      </Flex>
    </Flex>
  );
}
